
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class CouponList extends Vue
{
    /**
     * 优惠券类型map
     * @private
     * @returns object
     */
    private couponTypeMap: any = {
        fullReduce: 2,  // 满减
        discount: 4,    // 折扣
    };
    /**
     * 是否显示
     * @private
     * @returns string
     */
    @Prop({type: Boolean, default: false})
    private value: boolean;

    /**
     * 优惠券列表
     * @private
     * @returns array
     */
    @Prop({type: Array, default: []})
    private couponList: [];

    /**
     * 带入的优惠券
     * @private
     * @returns array
     */
    @Prop({default: null})
    private selectCouponId: any;

    /**
     * 是否显示
     * @private
     * @returns boolean
     */
    private get showCouponPopup(): boolean
    {
        return this.value;
    }

    /**
     * 返回弹框状态 
     * @private
     */
    private set showCouponPopup(value: boolean)
    {
        this.$emit("input", value);
    }

    /**
     * 当前选中优惠券
     * @protected
     * @returns string
     */
    protected activeCouponId: any = null;

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    protected get userInfo(): any
    {
        return this.$store.getters.userInfo || {};
    }

    /**
     * 当前选中优惠券
     * @private
     * @returns void
     */
    protected onSelectCoupon(item: any): void
    {
        if (this.activeCouponId == item.couponId) {
            this.activeCouponId = null;
        }
        else {
            this.activeCouponId = item.couponId;
        }
    }

    /**
     * 确认切换优惠券
     * @private
     * @returns void
     */
    protected onConfirmCoupon(bol): void
    {
        this.$emit("onConfirmCoupon", this.couponList.find((item: any) => item.couponId == this.activeCouponId));
        this.showCouponPopup = false;
    }

    /**
     * 关闭弹窗
     * @private
     * @returns void
     */
    protected closePop(): void {
        this.$emit("close");
    }

    /**
     * 组件创建钩子
     * @protected
     * @returns void
     */
    protected created()
    {
        if(!localStorage.getItem("userInfo"))
        {
            this.$router.replace({name:"login", query:{redirect: location.href}});
            return;
        }
        this.activeCouponId = this.selectCouponId;
    }

    /**
     * 监听优惠券变化
     * @private
     * @returns void
     */
    @Watch("selectCouponId")
    private async onChangeSelectCouponId(value: any): Promise<any>
    {
        if(value)
        {
            this.activeCouponId = this.selectCouponId;
        }
    }
}
